import { useState } from "react";

import { useNavigate } from "react-router-dom";  

const SeatType = ({ seatCategory }) => {
  const [quantity, setQuantity] = useState(1);
  const price = 3.5;

const navigate = useNavigate()



  return (
    <div className="flex flex-col items-center border-t w-full justify-center px-4 py-12">
      <h2 className="text-2xl font-bold mb-12 text-center">Select Seat Type</h2>

      {/* Seat image & info */}
      <div className="text-center mb-12">
        <div className="flex justify-center mb-4">
          <img
            src="/s1.png"
            alt="Standard Seat"
            className="h-24 w-auto"
          />
        </div>
        <p className="text-lg font-semibold">Standard</p>
        <p className="text-sm text-gray-500">41 Available</p>
        <p className="text-sm text-gray-500">KWD {price.toFixed(3)}</p>
      </div>

      {/* Ticket Quantity Section */}
      <div className="text-center border-t w-full max-w-md mb-8">
        <h2 className="text-2xl font-bold mb-20 mt-20 text-center">Select Ticket Quantity</h2>
        <div className="flex items-center justify-center gap-6 mb-6">
          <p className="text-lg font-semibold">Standard Ticket</p>
          <div className="flex items-center border border-gray-400 rounded-xl px-4 py-1">
            <button
              onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))}
              className="text-xl font-bold px-2"
            >
              −
            </button>
            <span className="mx-2">{quantity}</span>
            <button
              onClick={() => setQuantity((prev) => prev + 1)}
              className="text-xl font-bold px-2"
            >
              +
            </button>
          </div>
          <p className="text-lg font-semibold">KWD {(price * quantity).toFixed(3)}</p>
        </div>

        {/* Age limit and terms */}
        <div className="flex items-center justify-center gap-4  ">
           <div className="text-left text-md">
             <p className="text-gray-900">
              By clicking Proceed, I agree to the{" "}
              <a href="#" className="underline font-bold">terms & conditions.</a>
            </p>
          </div>
        </div>

        {/* Proceed Button */}
        <div className="mt-20">

        <button onClick={()=>{navigate('/map');localStorage.setItem("quant",quantity)}} className="bg-[#E12329] hover:bg-red-700 text-white font-bold py-2 px-12 rounded-lg ">
          PROCEED
        </button>
        </div>
      </div>
    </div>
  );
};

export default SeatType;
